// Accordion expand/collapse functionality
export function initSearchInputs() {
    const searchTrigger = document.getElementById('search-trigger') as HTMLButtonElement;
    const searchInputContainer = document.getElementById('search-input-container') as HTMLDivElement;
    const searchInput = document.getElementById('search-input') as HTMLInputElement;
    const searchClose = document.getElementById('search-close-btn') as HTMLButtonElement;
    const inactiveSearchIcon = document.querySelector('.search-inactive') as HTMLElement;
    const activeSearchIcon = document.querySelector('.search-active') as HTMLElement;

    if (!searchTrigger || !searchInputContainer || !searchInput || !searchClose || !inactiveSearchIcon || !activeSearchIcon) return;

    // Open search input
    searchTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        // console.log('Search trigger clicked', searchInputContainer);
        searchInputContainer.classList.remove('hidden');
        searchInputContainer.classList.add('flex', 'opacity-100');
        inactiveSearchIcon.classList.add('hidden');
        activeSearchIcon.classList.remove('hidden');
        searchInput.focus();
    });

    // Close search input
    searchClose.addEventListener('click', () => {
        searchInputContainer.classList.add('hidden');
        searchInputContainer.classList.remove('flex', 'opacity-100');
        inactiveSearchIcon.classList.remove('hidden');
        activeSearchIcon.classList.add('hidden');
        searchInput.value = '';
    });

    // Close search input on outside click
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        if (!searchInputContainer.contains(target) && target !== searchTrigger) {
            searchInputContainer.classList.add('hidden');
            searchInputContainer.classList.remove('flex', 'opacity-100');
            inactiveSearchIcon.classList.remove('hidden');
            activeSearchIcon.classList.add('hidden');
            searchInput.value = '';
        }
    });
}



